import { useState } from 'react';

function useModals() {
  const [visibleModal, setVisibleModal] = useState(null);
  const closeModal = () => setVisibleModal(null);
  return {
    visibleModal,
    openModal: setVisibleModal,
    closeModal,
  };
}

export default useModals;
